import type { UserMessagePayload } from '../../protocol/types';
import { AttachmentChip } from './AttachmentChip';
import { MessageMeta } from './MessageMeta';

interface Props {
  payload: UserMessagePayload;
  timestamp?: number | undefined;
  status?: 'sending' | 'sent' | 'failed';
  reactions?: string[];
  onRetry?: () => void;
}

/** A user turn — the only message kind rendered as a filled bubble. The
 *  timestamp + delivery state sit below the bubble, not inside it. */
export function UserMessage({ payload, timestamp, status, reactions, onRetry }: Props) {
  return (
    <div className="flex justify-end animate-fade-in">
      <div className="flex max-w-[82%] flex-col items-end sm:max-w-[68%]">
        <div className="rounded-[var(--radius-bubble)] rounded-br-md bg-user-bubble px-3.5 py-2 text-user-bubble-text shadow-sm">
          {payload.text ? (
            <div className="whitespace-pre-wrap break-words text-[15px] leading-relaxed">
              {payload.text}
            </div>
          ) : null}
          {payload.attachments && payload.attachments.length > 0 ? (
            <div className={`flex flex-wrap gap-1.5 ${payload.text ? 'mt-2' : ''}`}>
              {payload.attachments.map((a) => (
                <AttachmentChip key={a.id} attachment={a} variant="user" />
              ))}
            </div>
          ) : null}
        </div>
        <MessageMeta timestamp={timestamp} status={status} align="right" onRetry={onRetry} />
        {reactions && reactions.length > 0 ? (
          <div className="mt-1 flex gap-1">
            {reactions.map((r) => (
              <span
                key={r}
                className="rounded-full border border-divider bg-surface px-1.5 py-0.5 text-xs"
              >
                {r}
              </span>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
